module.exports = __webpack_public_path__ + "img/86.3e95d66d.jpg";